import { Component, OnInit, OnDestroy } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Subscription } from 'rxjs';

import { ProjectsEditorService, ProjectsService } from '@app/services/app/projects.service';
import { VersionsService, VersionsViewService } from '@app/services/app/versions.service';

import * as Objects from '@core/objects';
import { TitleService } from '@core/services/title.service';
import { ActivatedRoute } from '@angular/router';
import { ThreeDotsMenuItem } from '@core/components/helpers/navigation/three-dots-menu/three-dots-menu-item';
import { AppService } from '@app/services/app/app.service';
import { AppRouterService } from '@app/services/app/router.service';
import { AddProjectService } from '@app/services/app/add-project.service';
import { LibraryService } from '@app/services/app/library.service';
// models
import { AccessVersion, AccessVersionKeys, AccessVersionStatus, AccessProject, AccessProjectKeys } from '@app/models/access';
import * as fromFeedbacksModel from '@core/models/version-feedback';
import { VersionShare, isFeedbackVersionShare, isVersionShareOpen } from '@core/models/version-share.model';
import * as fromState from '@app/store/state/versions/versions.state';
@Component({
    selector: 'project-version-details-main',
    templateUrl: './version.component.html',
    styleUrls: ['./version.component.scss']
})
export class ProjectDetailsVersionDetailsComponent implements OnInit, OnDestroy {

    public readonly STATUS_LOADING = 0;
    public readonly STATUS_DONE = 1;
    public readonly STATUS_ERROR = 2;
    public readonly STATUS_NOT_FOUND= 4;
    public readonly STATUS_NOT_ACCESS_DONE= 5;

    public readonly PLUGIN_REQUEST_FEEDBACK = 'share_feedback';
    public readonly PLUGIN_SEND_FILES = 'share_transfer';
    public readonly ACCESS_ADD_PROJECT = "access_global_new_request";

    // for view reminder    
    public readonly VIEW_MODAL_NONE = 0;
    public readonly VIEW_APPROVAL_REMINDER_DONE = 1;
    public readonly VIEW_APPROVAL_REMINDER_ERROR = 2;
    public readonly VIEW_SELF_FEEDBACK_ERROR = 3;
    public readonly VIEW_SELF_FEEDBACK_DONE = 4;

    // feedback types
    public readonly FEEDBACK_TYPE_APPROVAL = 'approval';
    public readonly FEEDBACK_TYPE_COMMENTS = 'feedback';

    public version: Objects.Version = null;
    public project: Objects.Request = null;
    public projectHeader: Objects.Request = null;
    public user: Objects.User = null;
    public originProject: Objects.Request = null;
    public bcTitle: string = 'ARTWORK v. . . . <small>(# .  .  . )</small>';

    public excludedLabels: Array<Objects.Label> = [];

    public pluginsAccess: Array<string> = [];
    public accessProject: AccessProject;
    public versionAccess: AccessVersion = null;
    public uploadVersionAccess: boolean = false;
    public selfFeedbackAccess: boolean = false;
    public addProjectAccess: boolean = false;
    public selfFeedbackRequested: boolean = true; // by deafult we don't add self feedba buttons to 3dot menu
    public context: string = '';
    public modalView: number = this.VIEW_MODAL_NONE;

    public breadcrumbs: any = [];
    public menu: Array<ThreeDotsMenuItem> = [];
    public notLinkedArtwork: boolean = false;
    // optional menu items
    protected menuUploadVersion: ThreeDotsMenuItem = {
        title: "Upload Artwork",
        key: "upload-artwork",
        icon: "upload_artwork",
        order: 1
    };
    protected menuSendFiles: ThreeDotsMenuItem = {
        title: "Send",
        key: "send-files",
        icon: "send-files",
        order: 2
    };
    protected menuRequestFeedback: ThreeDotsMenuItem = {
        title: "Request Feedback",
        key: "feedback",
        icon: "feedback",
        order: 3
    };
    protected menuAddProject: ThreeDotsMenuItem = {
        title: "Start New Project",
        key: "add-project",
        icon: "add",
        order: 4
    };
    protected menuSeeOriginalProject: ThreeDotsMenuItem = {
        title: "See Original Project",
        key: "see-project",
        icon: "see-project",
        order: 5
    };
    protected menuEditTags: ThreeDotsMenuItem = {
        title: "Edit Tags",
        key: "edit",
        icon: "edit-tags",
        order: 6
    };
    protected menuReminder: ThreeDotsMenuItem = {
        title: "Send approval reminder",
        key: "send-reminder",
        icon: "approval-reminder",
        order: 7
    };
    protected menuRequestMyFeedback: ThreeDotsMenuItem = {
        title: "Add my comments",
        key: "add-my-comments",
        icon: "add-self-comments",
        order: 8
    };
    protected menuRequestMyApproval: ThreeDotsMenuItem = {
        title: "Add my approval",
        key: "add-my-approval",
        icon: "add-self-approval",
        order: 9
    };

    public status:number = this.STATUS_LOADING;
    protected subs = new Subscription();

    constructor(
        public app: AppService,
        private librarySrv: LibraryService,
        private title: TitleService,
        private activeRoute: ActivatedRoute,
        private projectsSrv: ProjectsService,
        private viewVersionsSrv: VersionsViewService,
        private projectEditorSrv: ProjectsEditorService,
        private AddProjectSrv: AddProjectService,
        private versionsSrv: VersionsService,
        private appRouter: AppRouterService
    ) { }

    ngOnInit() {

        // HERE LOAD version status Access on Library Store. 
        // this.librarySrv.loadVersionsStatusAccess();
        this.setDefaultBredcrumb();
        // set temporal header title
        this.title.set("Artwork... - Project...");
        // TE QUIERO RIDE COMO A MI BIKE - CHICKEN TERIYAKI
        this.subs.add(this.activeRoute.queryParams.subscribe((params: any) => {
            if (params.context) {
                this.context = params.context;
            }
        }));

        this.subs.add(this.projectEditorSrv.selectAccessAll().subscribe((access: AccessProject) => {
            if (access != null) {
                this.accessProject = access;
                this.initView();
            }
        }));

        this.subs.add(this.projectsSrv.selectProject().subscribe((project: Objects.Request) => {
            if (project == null) return;
            this.project = project;
            this.projectEditorSrv.loadSingleAccess(this.project.id);
            this.initView();
        }));

        this.subs.add(this.projectsSrv.selectProjectHeader().subscribe((header: Objects.Request) => {
            if (header == null) return;
            this.projectHeader = header;
            this.initView()
        }));

        this.subs.add(this.viewVersionsSrv.selectVersion().subscribe((version: Objects.Version) =>
        {
            this.version = version;
            if(version != null){
                this.bcTitle = 'ARTWORK v.'+ version.version+' <small>(#'+ version.id+')</small>';
                this.getVersionAccess();
            }
            this.initView();
        }));

        this.subs.add(this.viewVersionsSrv.selectProject().subscribe((projectOrigin: Objects.Request) => {
            this.originProject = projectOrigin
            this.initView();
        }));

        this.subs.add(this.activeRoute.params.subscribe((params: any) => {
            // console.log(" params ", params);
            this.viewVersionsSrv.load(+params.vid);
        
        }));

        // plugins & add project from session
        this.app.getSession().subscribe( (session: any) => {
            this.pluginsAccess = session.options.plugins;
            this.addProjectAccess = session.options.access.hasOwnProperty(this.ACCESS_ADD_PROJECT)? session.options.access[this.ACCESS_ADD_PROJECT] : false;
            this.user = session.current.user;
            this.initView();
        });

        this.subs.add(this.viewVersionsSrv.selectError('load_version').subscribe((error: HttpErrorResponse) => {
            this.setError(error)
        }));

        // subscriber for self feedback action status in store
        this.subs.add(this.viewVersionsSrv.selectSelfShareRequestActionStatus().subscribe((statusSF: fromState.VersionsActionStatus) => {
            if(statusSF.success){
                this.modalView = this.VIEW_SELF_FEEDBACK_DONE;
            }
            if (statusSF.error != null){
                    this.modalView = this.VIEW_SELF_FEEDBACK_ERROR;
            }
        }));
    }

    ngOnDestroy() {
        this.subs.unsubscribe();
        this.viewVersionsSrv.clear();
    }

    private initView() {
        if((this.project != null || this.projectHeader != null) && this.version != null){
            if (!this.isRelated()){
                console.debug(" The Artwork opened is not related to this project");
                this.notLinkedArtwork = true;
            }
            this.updateBreadcrumbs();
        }

        if(this.versionAccess == null || this.accessProject == null || (this.project == null && this.projectHeader == null) || this.version == null  || this.originProject == null)
            return;
        this.setVersionMenu();
        this.setHeaderTitle();
        if ((this.project != null && this.originProject.id != this.project.id) || (this.projectHeader != null && this.originProject.id != this.projectHeader.id) ){
            this.updateMenu(this.menuSeeOriginalProject);
        }
        this.status = this.STATUS_DONE;
    }

    private getVersionAccess(){
        this.subs.add(this.librarySrv.selectVersionStatusAccess(this.version.status.id).subscribe((AccessVS: AccessVersionStatus) => {
            if(AccessVS != null && AccessVS.access.grants && this.status != this.STATUS_NOT_ACCESS_DONE){
                this.versionAccess = AccessVS.access.grants;
                //   console.log(" version access ---->",this.versionAccess);
                this.updateMenu(this.menuEditTags, this.versionAccess.hasOwnProperty(AccessVersionKeys.EDIT_LABELS) ? this.versionAccess[AccessVersionKeys.EDIT_LABELS] : false);

                this.initView();
            }
        }));
    }

    private setHeaderTitle() {
        this.title.set("Artwork #"+ this.version.id + "- Project #" + (this.project ? this.project.id : this.projectHeader.id));
    }

    // we set this menu items only when we have the project access granted
    private setVersionMenu() : void {
        this.updateMenu(this.menuSendFiles, this.checkPluginAccess(this.PLUGIN_SEND_FILES) && this.accessProject.hasOwnProperty(AccessProjectKeys.SEND_FILE) && this.accessProject[AccessProjectKeys.SEND_FILE]);
        this.updateMenu(this.menuRequestFeedback, this.checkPluginAccess(this.PLUGIN_REQUEST_FEEDBACK) && this.accessProject.hasOwnProperty(AccessProjectKeys.SEND_REQUEST_FEEDBACK) && this.accessProject[AccessProjectKeys.SEND_REQUEST_FEEDBACK]);
        this.updateMenu(this.menuAddProject, this.addProjectAccess);

        this.updateMenu(this.menuUploadVersion, this.accessProject.hasOwnProperty(AccessProjectKeys.UPLOAD_VERSION) && this.accessProject[AccessProjectKeys.UPLOAD_VERSION] && this.project != null);
        
        if (this.checkPluginAccess(this.PLUGIN_REQUEST_FEEDBACK) && (this.project != null || this.projectHeader != null)) {

            // @deprecated oct-2026: legacy share feedback bubbles url call, replaced by selectVersionShares
            // this.subs.add(this.viewVersionsSrv.selectFeedbacks().subscribe((feedbacks: Array<fromFeedbacksModel.VersionFeedback>) => {
            //     if (feedbacks != null && feedbacks.some((f: fromFeedbacksModel.VersionFeedback) => (f.status != null && f.status.status_code == fromFeedbacksModel.FeedbackStatusCodeEnum.OPENED_CODE))) {
            //         this.updateMenu(this.menuReminder, this.checkPluginAccess(this.PLUGIN_REQUEST_FEEDBACK));
            //     } else {
            //         this.updateMenu(this.menuReminder, false);
            //     }
            //     // check we have some feedback request for current user
            //     if (feedbacks != null) {
            //         this.selfFeedbackRequested = feedbacks.some((f: fromFeedbacksModel.VersionFeedback) => (f.user.id === this.user.id));
            //     }
            //     this.updateSelfShareFeedbackMenus();
            // }))
            this.subs.add(this.viewVersionsSrv.selectVersionShares().subscribe((allShares: Array<VersionShare>) => {
                // reminders only apply to approval/feedback requests still waiting for the recipient
                if (allShares != null && allShares.some((vs: VersionShare) => isFeedbackVersionShare(vs) && isVersionShareOpen(vs))) {
                    this.updateMenu(this.menuReminder, this.checkPluginAccess(this.PLUGIN_REQUEST_FEEDBACK));
                } else {
                    this.updateMenu(this.menuReminder, false);
                }
                // check we have some feedback request for current user (any status: one request per recipient and version)
                if (allShares != null) {
                    this.selfFeedbackRequested = allShares.some((vs: VersionShare) => isFeedbackVersionShare(vs) && vs.entry?.user?.id === this.user.id);
                }
                this.updateSelfShareFeedbackMenus();
            }))
        }

    }

    onMenuClick(key: string) {
        const currentProject = this.project ?? this.projectHeader;
        switch(key) {
            case "upload-artwork":
                this.appRouter.navigate('/projects/'+this.project.id+'/versions/add', { queryParams: { links: this.version.labels.map((l: Objects.Label) => l.id).sort().join("-") } });
                break;
            case "add-project":
                if(this.version != null){
                    // clean new project store just in case
                    this.AddProjectSrv.clear();
                    this.appRouter.navigate('/projects/add', { queryParams: { version: this.version.id} });
                }
                break;
            case "see-project":
                this.appRouter.navigate('/projects/'+this.originProject.id);

                break;
            case "feedback":
                if (this.checkPluginAccess(this.PLUGIN_REQUEST_FEEDBACK))
                    // @deprecated oct-2026: legacy plugin prefix route
                    // this.appRouter.navigate('/p/feedback/' + currentProject.id, { queryParams: { version: this.version.id} });
                    this.appRouter.navigate('/feedback/project/' + currentProject.id, { queryParams: { version: this.version.id} });
                break;
            case "send-files":
                if (this.checkPluginAccess(this.PLUGIN_SEND_FILES))
                    this.appRouter.navigate('/p/transfer/' + currentProject.id, { queryParams: { version: this.version.id} });
                break;
            case "send-reminder":
                if (this.checkPluginAccess(this.PLUGIN_REQUEST_FEEDBACK))
                    this.versionsSrv.sendFeedbackReminder$([this.version]).subscribe(
                        (data:any) => {
                            console.debug(" REMINDER IS DONEEEE ", data)
                            this.modalView = this.VIEW_APPROVAL_REMINDER_DONE;
                        },
                        (error:any) => {
                            console.debug(" THIS REMINDER FAILED because DRAMA ", error)
                            this.modalView = this.VIEW_APPROVAL_REMINDER_ERROR;
                        }
                    );
                break;
            case "add-my-comments":
                if(this.checkPluginAccess(this.PLUGIN_REQUEST_FEEDBACK)){
                    this.requestMyComments();
                }
                break;
            case "add-my-approval":
                if(this.checkPluginAccess(this.PLUGIN_REQUEST_FEEDBACK)){
                    this.requestMyApprovalWithSign();
                }
                break;
        }
    }

    protected updateBreadcrumbs(){
        if(this.project == null && this.projectHeader == null || this.version == null)
            return;
        // PENDING IF THE CONTEXT IS FINALLY NECESSARY
        switch (this.context) {
            case "related":
            default:
                const currentProject = this.project != null ? this.project : this.projectHeader;
                // this.excludedLabels = currentProject.labels;
                this.excludedLabels = this.version.labels.filter((vLabel: Objects.Label) =>
                    currentProject.labels.some((pLabel: Objects.Label) => pLabel.id === vLabel.id)
                );
                this.breadcrumbs[0] = {link: '/projects/'+currentProject.id,
                                        title: 'Project <small>(#'+currentProject.id+ ')</small>'};
                break;
        }
    }

    onStatusUpdate(status: Objects.Status) {
        this.viewVersionsSrv.setStatus(status);
    }

    onModalDismiss(e){
        this.modalView = this.VIEW_MODAL_NONE;
    }

    onSFModalDismiss(e){
        this.viewVersionsSrv.resetSelfShareRequestActionStatus();
        this.onModalDismiss(e);
    }

    protected checkPluginAccess(plugin: string){
        return this.pluginsAccess.some((pa) => pa == plugin);
    }

    // this function check either remove or add item. based on subscribed events
    protected updateMenu(item: ThreeDotsMenuItem, addItem:boolean = true) {
        this.menu = this.menu.filter((i: ThreeDotsMenuItem) => item.key != i.key);
        if(addItem){
            this.menu.push(item);
        }
    }

    // the common tags between project and version should be all of the project.
    protected isRelated(){
        let labelsToCheck = this.project != null ? this.project.labels : this.projectHeader.labels;
        let common = labelsToCheck.filter((pl: Objects.Label) => this.version.labels.some((vl: Objects.Label) => vl.id == pl.id));
        if (common.length == labelsToCheck.length)
            return true;
        return false;
    }


    protected setError(error: HttpErrorResponse) {
        // console.log("we have errors ",error)
        if(error == null)
            return;
        switch(error.status) {
            case 500:
                this.status = this.STATUS_ERROR;
                break;
            case 404:
                this.status = this.STATUS_NOT_FOUND;
                break;
            case 206:
                this.status = this.STATUS_NOT_ACCESS_DONE;
                break;
            case 200:
                this.status = this.STATUS_DONE;
                break;
        }
    }

    protected setDefaultBredcrumb(){
        this.breadcrumbs[0] = {link: '',
                            title: 'Project <small>( # . . . )</small>'};
    }

    protected updateSelfShareFeedbackMenus(){
        if (this.accessProject[AccessProjectKeys.ADD_MY_FEEDBACK] && this.checkPluginAccess(this.PLUGIN_REQUEST_FEEDBACK) && this.accessProject.hasOwnProperty(AccessProjectKeys.SEND_REQUEST_FEEDBACK) && this.accessProject[AccessProjectKeys.SEND_REQUEST_FEEDBACK]){
            // we use the selfFeedbackRequested to update the menu. menu is there when user has NOT feedback requested
            this.updateMenu(this.menuRequestMyFeedback,!this.selfFeedbackRequested); 
            this.updateMenu(this.menuRequestMyApproval,!this.selfFeedbackRequested);
        }
    }

    protected requestMyComments(){
        let customData = { 
            type: "feedback",
            request: this.project ? this.project.id : this.projectHeader.id, // added in dec-2024 and updated in jan-2026 <diego@twonas.com>
            get_approval: false,
            get_signature: false,
            get_comments: true, 
            allow_see: true,
        }
        this.onSubmitFeedbackRequest(customData);
    }

    protected requestMyApprovalWithSign(){
        let customData = { 
            type: "feedback",
            request: this.project ? this.project.id : this.projectHeader.id, // added in dec-2024 and updated in jan-2026  <diego@twonas.com>
            get_approval: true,
            get_signature: true,
            get_comments: true, 
            allow_see: true,
        }
        this.onSubmitFeedbackRequest(customData);
    }

    protected onSubmitFeedbackRequest(optionsData: any) {
        let labels = this.project ? this.project.labels.map(l => l.name).join(", ") : this.projectHeader.labels.map(l => l.name).join(", ");
        // this.modalButtonDisabled = true;
        let typeFeedbackText = optionsData.get_approval ? 'approval' : 'feedback';
        const postData = {...optionsData,
            // Twona AMS - prefix already set on backend
            subject: this.user.name + " is requesting your "+typeFeedbackText+" on " + labels,
            message: "Please see files for you to review.",
            emails: [this.user.email]
        }
        // update menu 3 dot to remove self feedabck buttons.
        this.selfFeedbackRequested = true;
        this.updateSelfShareFeedbackMenus();
        this.viewVersionsSrv.sendSelfShareRequest(postData);
    }


}
